module.exports = __webpack_public_path__ + "files/patient.c5077a05d6792a6feba38076826772ab.pdf";